import BaseModel from './base';
import { localeFormatDefault } from '@/plugins/date-print';

export default class NominationOptions extends BaseModel {
  constructor(options, url) {
    super(options, url);

    this.nomination_id = options.nomination_id;

    this.is_with_moderation = options.is_with_moderation;

    this.block_request_groups_ids = options.block_request_groups_ids || [];
    this.max_participants = options.max_participants || null;

    this.start_accepting_at = localeFormatDefault(options.start_accepting_at);
    this.end_accepting_at = localeFormatDefault(options.end_accepting_at);

    // При подаче заявки можно не указывать конкретную категорию
    this.block_request_without_group = options.block_request_without_group;
  }
}
